<template>
    <v-container>
        <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
                <v-card v-if="item">
                  <v-btn text block router :to="'/listing/' + listingId">
                    <v-icon>keyboard_arrow_left</v-icon>
                    back to listing
                  </v-btn>
                    <v-card-title>
                        <h2>{{item.title}}</h2>
                      <v-spacer></v-spacer>
                      <!--                      Listed unlisted-->
                      <v-switch
                          color="blue"
                          v-model="item.listed"
                          label="Listed"
                      ></v-switch>
                    </v-card-title>
                    <v-carousel
                            cycle
                            hide-delimiter-background
                            show-arrows
                            height="200"
                    >
                        <v-carousel-item
                                v-for="img in item.imgs"
                                :key="img.id"
                        >
                            <v-img
                                    :src="img.url"
                                    height="200px"
                                    contain
                                    @click="imageSelected(img.id)"
                            ></v-img>
                        </v-carousel-item>
                    </v-carousel>
                  <v-btn block outlined class="success--text mb-2" @click="openImgUploadDialog">
                    <v-icon>photo</v-icon>
                    Upload Image</v-btn>
                  <v-btn block class="blue white--text mb-6" @click="updateItem" outlined>Update</v-btn>
                    <v-card-text>
<!--                      title  -->
                      <v-text-field
                            v-model="item.title"
                            label="Name"
                        ></v-text-field>
<!--                      price per km-->
                      <v-text-field
                          rows="3"
                          v-model="item.kmPrice"
                          label="Price per km"
                          type="number"
                      >
                      </v-text-field>
<!--                      price per minute-->
                      <v-text-field
                          rows="3"
                          v-model="item.minutePrice"
                          label="Price per minute"
                          type="number"
                      >
                      </v-text-field>
<!--                      price per unit-->
                      <v-text-field
                          rows="3"
                          v-model="item.unitPrice"
                          label="Price per unit"
                      >
                      </v-text-field>
                      <!--                      cost per unit-->
                      <v-text-field
                          rows="3"
                          v-model="item.unitCost"
                          label="Cost per unit"
                      >
                      </v-text-field>
<!--                      instruction-->
                        <v-text-field
                                v-model="item.instruction"
                                label="Instruction"
                        >
                        </v-text-field>
<!--                      note-->
                        <v-textarea
                                v-model="item.note"
                                label="Item Description"
                                rows="4"
                        >
                        </v-textarea>
                    </v-card-text>
                </v-card>
                <v-btn v-if="item" block text outlined class="mt-6 red--text" @click="deleteDialog = true">delete</v-btn>
            </v-flex>
            <v-dialog v-model="imageDialog"
                    width="500px"
            >
                <v-card>
                  <v-img
                      v-if="pickedImage"
                      :src="pickedImage.url"
                      contain
                      height="500px"
                  >
                  </v-img>
                  <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn outlined @click="deleteImage" class="red white--text">delete</v-btn>
                        <v-btn @click="imageDialog = false">close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
          <v-dialog v-model="deleteDialog"
                    ref="dialog"
                    persistent
                    width="290px"
          >
            <v-card v-if="item">
              <v-card-title>
                <div class="white black--text text-xs-center font-weight-thin display-1">Warning</div>
              </v-card-title>
              <v-card-text>
                {{item.title}} will be deleted forever.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="deleteDialog = false" text>cancel</v-btn>
                <v-btn @click="deleteItem()" dark class="error">delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="imageUploadDialog"
                    ref="dialog"
                    persistent
                    width="500px"
          >
            <v-card>
              <v-card-title>Select image to upload</v-card-title>
              <gen-img-uploader path="inventoryContent" @imageLinkFound="addImageLink" @removeImage="removeImageLink"></gen-img-uploader>
              <v-card-text v-if="mediaUrl">
                <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="!mediaUrl" @click="uploadImgToItem">ok</v-btn>
                <v-btn text @click="cancelImageUpload">cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
    </v-container>
</template>
<script>
import {getDoc, setDoc, deleteDoc, updateDoc, doc, onSnapshot} from "firebase/firestore";
import {deleteObject, getStorage, ref} from "firebase/storage";
    export default {
      props: ['listingId', 'itemId'],
      data () {
        return {
          item: undefined,
          imageDialog: false,
          pickedImage: undefined,
          deleteDialog: false,
          imageUploadDialog: false,
          mediaUrl: undefined,
          imgId: ''
        }
      },
      computed: {
        user () {
          return this.$store.getters.user
        }
      },
      created() {
        //console.log(this.id)
        let db = this.$store.state.db
        let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.listingId + '/addOnItems/' + this.itemId)
        onSnapshot(itemRef, res => {
          if(res.exists) {
            let data = res.data()
            let item = {...data}
            //console.log(res.data())
            this.item = item

          }
        })
      },
        methods: {
        openImgUploadDialog() {
          this.imageUploadDialog = true
        },
        updateItem () {
          let db = this.$store.state.db
          let publicListingItemRef = doc(db, 'publicListings', this.user.publicListingId, 'listings', this.listingId, 'addOnItems', this.itemId)
          let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.listingId + '/addOnItems/' + this.itemId)
          return updateDoc(itemRef, this.item)
          .then (() => {
            if (this.item.listed) {
              let obj = {...this.item}
              delete obj.unitCost
              return setDoc(publicListingItemRef, obj)
            } else {
              let publicListingItemRef = doc(db, 'publicListings', this.user.publicListingId, 'listings', this.listingId, 'addOnItems', this.itemId)
              return getDoc(publicListingItemRef)
            }
          })
          .then (res => {
            if(!this.item.listed) {
               if (res.exists) {
                 deleteDoc(publicListingItemRef)
               }
            }
          })
          .catch(err => {
             this.$store.dispatch('setError', err)
          })
          // console.log(this.item)
        },
          imageSelected (value) {
            this.pickedImage = this.item.imgs.find(img => {
              return img.id === value
            })
            //console.log(this.pickedImage)
            this.imageDialog = true
          },
          deleteItem () {
            let db = this.$store.state.db
            let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.listingId + '/addOnItems/' + this.itemId)
            this.item.listed= false
            return updateDoc(itemRef, this.item)
            .then(()=> {
              return deleteDoc(itemRef)
            })
            .then (() => {
              if (this.item.listed) {
                let publicListingItemRef = doc(db, 'publicListings', this.user.publicListingId, 'listings', this.listingId, 'addOnItems', this.itemId)
                return deleteDoc(publicListingItemRef)
              }
            })
            .then (()=> {
              this.$router.push('/listing/' + this.listingId)
            })
          },
          deleteImage () {
            let index = this.item.imgs.indexOf(this.pickedImage)
            this.item.imgs.splice(index, 1)
            this.imageDialog = false
            this.updateItem()
            let userId = this.user.uid
            let storage = getStorage()
            let imgRef = ref(storage, '/users/' + userId + '/inventoryContent/' + this.pickedImage.id)
            deleteObject(imgRef).catch((err) => {
              console.log(err)
              this.$store.dispatch('setError', err)
            });
          },
          addImageLink (value) {
            this.mediaUrl = value.url
            this.imgId = value.id
          },
          uploadImgToItem () {
            this.item.imgs.push({
              id: this.imgId,
              url: this.mediaUrl
            })
            this.updateItem()
            this.imageUploadDialog = false
            this.mediaUrl = undefined
          },
          removeImageLink () {
            this.mediaUrl = undefined,
                this.imgId = ''
          },
          cancelImageUpload () {
            this.imageUploadDialog = false
            this.mediaUrl = undefined
          },
          // in progress
          selectImgFromContent (link) {
            this.mediaUrl = link
            console.log(link)
          },
          saveImageUrl (link) {
            this.imageUrl = link
            this.addImageToCollection()
          },
          addImageToCollection () {
            // let contentRef = this.$store.state.db.collection('content')
            // contentRef.add({created: Date.now(), imageUrl: this.imageUrl, type: "image"})
            //     .then(() => {
            //       this.loadContent()
            //     })
            //     .catch(err => {
            //       this.$store.dispatch('setError', err)
            //     })
          }
        }
    }
</script>
